import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({ selector: '[spHost]' })
export class SpHostDirective {
    readonly viewContainerRef = inject(ViewContainerRef);
}
